import { render, staticRenderFns } from "./CommonProblem.vue?vue&type=template&id=9321d8e4&scoped=true&"
var script = {}
import style0 from "./CommonProblem.vue?vue&type=style&index=0&id=9321d8e4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9321d8e4",
  null
  
)

export default component.exports